"use client";

import { ReactNode } from "react";
import {
  LayoutDashboard,
  Briefcase,
  FileText,
  Award,
  FileCheck,
  Clock,
  User,
} from "lucide-react";
import { Header, Sidebar, NavItem } from "@/components/layouts";
import { ProtectedRoute } from "@/components/auth";

// =============================================================================
// Navigation Configuration
// =============================================================================

const nurseNavItems: NavItem[] = [
  {
    label: "Dashboard",
    href: "/dashboard",
    icon: LayoutDashboard,
  },
  {
    label: "Jobs",
    href: "/jobs",
    icon: Briefcase,
  },
  {
    label: "My Applications",
    href: "/applications",
    icon: FileText,
  },
  {
    label: "My Credentials",
    href: "/my-compliance",
    icon: Award,
  },
  {
    label: "My Contracts",
    href: "/contracts",
    icon: FileCheck,
  },
  {
    label: "Timesheets",
    href: "/timesheets",
    icon: Clock,
  },
  {
    label: "Profile",
    href: "/profile",
    icon: User,
  },
];

// =============================================================================
// Layout Component
// =============================================================================

interface NurseLayoutProps {
  children: ReactNode;
}

export default function NurseLayout({ children }: NurseLayoutProps) {
  return (
    <ProtectedRoute requireRole="nurse" requireVerified>
      <div className="min-h-screen bg-slate-50">
        <Header userType="nurse" />
        <Sidebar navItems={nurseNavItems} />
        {children}
      </div>
    </ProtectedRoute>
  );
}
